import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom'
import Breadcrumb from '../common/breadcrumb';
import data from '../../assets/data/listUser';
import Datatable from '../common/datatable'
import VerUserDatatable from '../common/ver-user-datatable';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
import Modal from 'react-responsive-modal';
import Select from 'react-select';

export class Ver_list_user extends Component {

    constructor(props) {
        super(props);
        this.handler = this.handler.bind(this);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        this.handlerAssignCluster = this.handlerAssignCluster.bind(this);
        this.handleClusterChange = this.handleClusterChange.bind(this);
        this.handleAssignCluster = this.handleAssignCluster.bind(this);
        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.state = {
            dataCateg: [],
            results: [],
            filter: '',
            temp: [],
            openClusterModal: false,
            selectedUserId: null,
            selectedUserName: '',
            selectedCluster: null,
            currentCluster: null,
            clusters: [],
            stats: null,
        };
    }

    handler(data_row) {
        this.props.history.push("/edit-user/"+data_row.original.id);
        window.location.reload();
    }

    deleteUser(data_row) {
       Swal.fire({
        title: 'Confirmar',
        text: '¿Desea eliminar '+ data_row.original.Nombre + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33', 
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar'
     }).then((result) => {
        if(result.value){
            
            var user = AuthService.getCurrentUser();
            ApiService.deleteUser(user.token,data_row.original.id).then(
                (res) => {
                    toast.success("Usuario eliminado!");
                    this.getDataUser();
                    //this.props.history.push("/category");
                    //window.location.reload();
                },
                error => {
                const resMessage =
                    (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
                }
            )
       }
     })
    }

    onChangeFilter(e) {

        this.setState({
            filter: e.target.value
        }, function () {
        });

        const val = e.target.value.toLowerCase();
        if (this.state.temp.length != 0) {
          var columns = Object.keys(this.state.temp[0]);
          //Los botones de acciones se pintan despues
          columns.splice(columns.length);
          //columns.splice(columns.length - 1);
    
          if (!columns.length)
            return;
          const rows = this.state.temp.filter(function (d) {
            for (let i = 0; i <= columns.length; i++) {
              let column = columns[i];
              if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
                return true;
              }
            }
          });
          
          this.setState({
            results: rows
        }, function () {

            this.renderResults(this.state.results.length);
        });

        }



        e.preventDefault();
      }
      
    componentWillMount() {
        this.getDataUser();
        this.getDataClusters();
        this.getStats();
    }

    getStats() {
        var user = AuthService.getCurrentUser();
        ApiService.getUserStats(user.token).then(
            (res) => {
                if (res && res.status === 'success') {
                    this.setState({ stats: res.data });
                }
            },
            error => {
            }
        );
    }

    getDataClusters(){
        var user = AuthService.getCurrentUser();
        ApiService.getCustomerClusters(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const clusters = res.data.map(function(row) {
                        return {
                            value: row.id,
                            label: row.cluster_name
                        }
                    })
                    this.setState({ clusters: clusters });
                }
            },
            error => {
            }
        );
    }

    onOpenModal = () => {
        this.setState({ openClusterModal: true });
    };

    onCloseModal = () => {
        this.setState({
            openClusterModal: false,
            selectedUserId: null,
            selectedUserName: '',
            selectedCluster: null,
            currentCluster: null,
        });
    };

    handlerAssignCluster(data_row) {
        var user = AuthService.getCurrentUser();
        this.setState({
            selectedUserId: data_row.original.id,
            selectedUserName: data_row.original.Nombre,
        });

        // Obtener el cluster actual del usuario
        ApiService.getUserCluster(user.token, data_row.original.id).then(
            (res) => {
                if(res && res.status == 'success'){
                    if(res.data){
                        this.setState({
                            currentCluster: res.data,
                            selectedCluster: {
                                value: res.data.id,
                                label: res.data.cluster_name
                            }
                        });
                    }
                }
                this.onOpenModal();
            },
            error => {
                this.onOpenModal();
            }
        );
    }

    handleClusterChange = (selectedOption) => {
        this.setState({ selectedCluster: selectedOption });
    };

    handleAssignCluster = () => {
        var user = AuthService.getCurrentUser();

        if (!this.state.selectedCluster) {
            Swal.fire("Por favor selecciona un grupo.");
            return;
        }

        let data = {
            id_user: this.state.selectedUserId,
            id_cluster: this.state.selectedCluster.value
        };

        ApiService.assignUserToCluster(user.token, data).then(
            (res) => {
                if(res){
                    if(res.status == 'success'){
                        toast.success(res.message);
                        this.onCloseModal();
                        this.getDataUser();
                    }
                    if(res.status == 'error'){
                        Swal.fire(res.message);
                    }
                }
            },
            error => {
                toast.error("Ha ocurrido un error al asignar el grupo!");
            }
        );
    };

    getDataUser(){
        var user = AuthService.getCurrentUser();
        ApiService.getConfirmUsers(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const items = res.data.map(function(row) {
                        return { 
                            id: row.id, 
                            Nombre : row.name + ' ' + row.last_name, 
                            Celular : row.Profile?row.Profile.cell_phonenumber:'',
                            Rol : row.role,
                            'Ref. General': row.mainreferer_name ? row.mainreferer_name : '',
                            Embajador: (row.Referred && row.Referred.name?row.Referred.name:'')+' '+(row.Referred && row.Referred.last_name?row.Referred.last_name:''),
                            Pin: row.pin_code,
                        }
                     })
                this.setState({ results:items });
                this.setState({ temp:items });
                this.renderResults(this.state.results.length);
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    renderResults(length){
		return this.state.results.length === 0
			? 'No hay datos.'
			: <VerUserDatatable
            multiSelectOption={false}
            myData={this.state.results}
            pageSize={length<=10?length:10}
            pagination={true}
            class="-striped -highlight"
            handler = {this.handler}
            deleteUser = {this.deleteUser}
            handlerAssignCluster = {this.handlerAssignCluster}
        />
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Lista de Usuarios" parent="Users" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-sm-4 mb-3">
                            <div className="card o-hidden mb-0">
                                <div className="bg-primary b-r-4 card-body" style={{padding:'20px'}}>
                                    <div style={{display:'flex', alignItems:'center', gap:'16px'}}>
                                        <div style={{
                                            background:'rgba(255,255,255,0.2)',
                                            borderRadius:'50%',
                                            width:'52px', height:'52px',
                                            display:'flex', alignItems:'center', justifyContent:'center',
                                            flexShrink:0
                                        }}>
                                            <i className="icon-user" style={{fontSize:'1.5rem', color:'#fff'}}></i>
                                        </div>
                                        <div>
                                            <div style={{color:'rgba(255,255,255,0.8)', fontSize:'0.8rem', textTransform:'uppercase', letterSpacing:'0.5px'}}>Total Usuarios</div>
                                            <div style={{color:'#fff', fontWeight:700, fontSize:'1.8rem', lineHeight:1.1}}>
                                                {this.state.stats ? this.state.stats.total_users : '—'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-4 mb-3">
                            <div className="card o-hidden mb-0">
                                <div className="bg-success b-r-4 card-body" style={{padding:'20px'}}>
                                    <div style={{display:'flex', alignItems:'center', gap:'16px'}}>
                                        <div style={{
                                            background:'rgba(255,255,255,0.2)',
                                            borderRadius:'50%',
                                            width:'52px', height:'52px',
                                            display:'flex', alignItems:'center', justifyContent:'center',
                                            flexShrink:0
                                        }}>
                                            <i className="icon-users" style={{fontSize:'1.5rem', color:'#fff'}}></i>
                                        </div>
                                        <div>
                                            <div style={{color:'rgba(255,255,255,0.8)', fontSize:'0.8rem', textTransform:'uppercase', letterSpacing:'0.5px'}}>Total Clientes</div>
                                            <div style={{color:'#fff', fontWeight:700, fontSize:'1.8rem', lineHeight:1.1}}>
                                                {this.state.stats ? this.state.stats.total_clients : '—'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-4 mb-3">
                            <div className="card o-hidden mb-0">
                                <div className="bg-warning b-r-4 card-body" style={{padding:'20px'}}>
                                    <div style={{display:'flex', alignItems:'center', gap:'16px'}}>
                                        <div style={{
                                            background:'rgba(255,255,255,0.2)',
                                            borderRadius:'50%',
                                            width:'52px', height:'52px',
                                            display:'flex', alignItems:'center', justifyContent:'center',
                                            flexShrink:0
                                        }}>
                                            <i className="icon-check" style={{fontSize:'1.5rem', color:'#fff'}}></i>
                                        </div>
                                        <div>
                                            <div style={{color:'rgba(255,255,255,0.8)', fontSize:'0.8rem', textTransform:'uppercase', letterSpacing:'0.5px'}}>Actualizaron Datos</div>
                                            <div style={{color:'#fff', fontWeight:700, fontSize:'1.8rem', lineHeight:1.1}}>
                                                {this.state.stats
                                                    ? `${this.state.stats.clients_updated_campaign} / ${this.state.stats.total_clients}`
                                                    : '—'}
                                            </div>
                                            {this.state.stats && this.state.stats.total_clients > 0 && (
                                                <div style={{color:'rgba(255,255,255,0.85)', fontSize:'0.8rem', marginTop:'2px'}}>
                                                    {Math.round((this.state.stats.clients_updated_campaign / this.state.stats.total_clients) * 100)}% completado
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <div style={{
                                display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'center',
                                justifyContent: 'space-between', marginBottom: 16,
                            }}>
                                <h5 style={{ margin: 0 }}>Usuarios</h5>
                                <Link to="/create-user" className="btn btn-secondary" style={{ margin: 0 }}>
                                    Crear Usuario
                                </Link>
                            </div>
                            <div style={{ marginBottom: 16 }}>
                                <input
                                    placeholder="Escriba para filtrar todas las columnas"
                                    name="filter"
                                    type="text"
                                    autoComplete="off"
                                    onInput={this.onChangeFilter}
                                    style={{
                                        width: '100%', borderRadius: 8, border: '1px solid #ddd',
                                        padding: '8px 12px', fontSize: 14, margin: 0,
                                    }}
                                />
                            </div>
                            <div id="batchDelete" className="category-table user-list order-table coupon-list-delete">
                                {this.renderResults()}
                            </div>
                        </div>
                    </div>
                </div>

                <Modal open={this.state.openClusterModal} onClose={this.onCloseModal} center>
                    <div className="modal-header">
                        <h5 className="modal-title">Asignar Grupo a Usuario</h5>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label><strong>Usuario:</strong> {this.state.selectedUserName}</label>
                        </div>
                        {this.state.currentCluster && (
                            <div className="form-group">
                                <label><strong>Grupo Actual:</strong> {this.state.currentCluster.cluster_name}</label>
                            </div>
                        )}
                        <div className="form-group">
                            <label>Seleccionar Grupo</label>
                            <Select
                                value={this.state.selectedCluster}
                                onChange={this.handleClusterChange}
                                options={this.state.clusters}
                                placeholder="Selecciona un grupo..."
                                isClearable={true}
                            />
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={this.onCloseModal}
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.handleAssignCluster}
                        >
                            Asignar Grupo
                        </button>
                    </div>
                </Modal>
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Ver_list_user
